import StatusWorkOrderList from '@/components/Settings/Profiles/StatusWorkOrder/StatusWorkOrderList';
import StatusWorkOrderModal from '@/components/Settings/Profiles/StatusWorkOrder/StatusWorkOrderModal';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function StatusWorkOrderPage({ route }: PageProps) {
  const intl = useIntl();
  const { Title, Paragraph } = Typography;

  const [modalOpened, modalActions] = useDisclosure();

  return (
    <>
      <div className="page">
        <Helmet title={intl.formatMessage({ id: route.name })} />
        <div className="page-header">
          <Title level={4}>{intl.formatMessage({ id: route.name })}</Title>

          <Button type="primary" onClick={modalActions.open}>
            Criar Status
          </Button>
        </div>

        <Paragraph style={{ marginTop: '16px' }}>
          Crie status customizados, para identificação dos veículos no pátio da
          sua oficina, vinculando-os as ordens de serviços
        </Paragraph>

        <StatusWorkOrderList />
      </div>

      <StatusWorkOrderModal open={modalOpened} onCancel={modalActions.close} />
    </>
  );
}
